import Upload from 'antd/lib/upload';
export type { UploadProps, UploadListProps, DraggerProps, UploadChangeParam } from 'antd/lib/upload';
export type { UploadFile, RcFile } from 'antd/lib/upload/interface';

export default Upload;
